import { post } from '../../service/Base';

export const checkTokenRequest = (token) => {
  if (!token) {
    return Promise.resolve({ valid: false, status: 401 });
  }
  return post('/check-token', { token }).then((response) => {
    if (response?.status !== 200) {
      return { valid: false, status: response?.status || 500 };
    }
    return response.data;
  });
};
